import { Tooltip } from '@mui/material';
import Typography from '@mui/material/Typography';
import ReactComponent from '../ReactComponent';
import { grey } from '@mui/material/colors';
import { inject, observer } from 'mobx-react';
import { makeObservable } from 'mobx';

class LabelOrdenacao extends ReactComponent {
    constructor(props) {
        super(props);
        makeObservable(this);
    }

    render() {
        return (
            <Tooltip title={this.observableProps.titulo}>
                <Typography
                    variant="h6"
                    data-expand
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        fontSize: '11pt',
                        whiteSpace: 'nowrap',
                        minWidth: '24px',
                        justifyContent: 'center',
                        cursor: 'default',
                        backgroundColor: grey[200],
                        borderRadius: this.observableProps.circular ? '50%' : '16px',
                        border: `1px solid ${grey[500]}`,
                        margin: '1px',
                        py: '3px',
                        px: this.observableProps.circular ? '3px' : 1,
                        aspectRatio: this.observableProps.circular ? 1 : 'auto'
                    }}
                >
                    {this.observableProps.conteudo}
                </Typography>
            </Tooltip>
        );
    }
}

export default inject('stores')(observer(LabelOrdenacao));
